import { render, staticRenderFns } from "./GroupBotNotify.vue?vue&type=template&id=6ab8f13d&scoped=true"
import script from "./GroupBotNotify.vue?vue&type=script&lang=js"
export * from "./GroupBotNotify.vue?vue&type=script&lang=js"
import style0 from "./GroupBotNotify.vue?vue&type=style&index=0&id=6ab8f13d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab8f13d",
  null
  
)

export default component.exports